import * as React from "react"
const TravelIcon = (props) => (
    <img src="/Icons/travel.svg" alt="travel" {...props}/>
)
export default TravelIcon